import type { LevelUpCard } from '../../../core/progression';
import type { DerivedChange } from '../../../core/stats';
import { changeText } from '../derivedText';
import { hudState } from '../state';
import { useHotkeys } from '../useHotkeys';

const KIND_LABEL: Record<LevelUpCard['kind'], string> = { spell: 'Nouveau sort', upgrade: 'Amélioration', passive: 'Passif' };

/** `effects[i]` : effet de la carte i sur les stats dérivées (« +25 % Dégâts »), calculé par le coeur. */
export function LevelUp({ cards, effects = [], rerolls }: { cards: LevelUpCard[]; effects?: DerivedChange[][]; rerolls: number }) {
  const choose = (i: number): void => { if (i < cards.length) hudState.send({ type: 'chooseCard', index: i }); };
  useHotkeys(true, choose);
  // la clé suit les ids : des montées de niveau consécutives re-rendent le panneau avec les nouvelles cartes
  const cardsKey = cards.map((c) => c.id).join('|');
  return (
    <div class="panel levelup-panel" key={cardsKey}>
      <h2>Montée de niveau ! Choisissez une carte</h2>
      <div class="cards">
        {cards.map((c, i) => (
          <button key={c.id} class={`card card-${c.kind}`} onMouseDown={(e) => e.preventDefault()} aria-label={`Carte ${i + 1} : ${c.name}`} onClick={() => choose(i)}>
            <span class="card-key">{i + 1}</span>
            {c.icon && <img class="card-icon" src={`/assets/${c.icon}.png`} alt="" />}
            <small class="card-kind">{KIND_LABEL[c.kind]}</small>
            <b>{c.name}</b>
            <p>{c.description}</p>
            {(effects[i]?.length ?? 0) > 0 && <small class="card-effect">{effects[i]!.map(changeText).join(', ')}</small>}
          </button>
        ))}
      </div>
      <button class="reroll" onMouseDown={(e) => e.preventDefault()} aria-label={`Relancer les cartes (${rerolls} restantes)`} disabled={rerolls <= 0} onClick={() => hudState.send({ type: 'rerollCards' })}>Relancer ({rerolls})</button>
    </div>
  );
}
